module.exports = {
  "country": "NL",
  "artist": "Maribelle",
  "song": "Ik Hou Van Jou",
  "year": "1984",
  "place": "13",
  "spotify": "5DeSdxlppND4LAS2OPK9sv"
};